import React, { useState, useCallback } from 'react';
import { MdOutlineCancel } from 'react-icons/md';

const INITIAL_FORM_STATE = {
  targetPrice: '',
  targetJeonse: '',
};

export default function BookmarkModal({
  isOpen,
  onClose,
  onConfirm,
  apartmentName,
  aptNo,
  availableAreas = [],
}) {
  const [selectedArea, setSelectedArea] = useState(null);
  const [formState, setFormState] = useState(INITIAL_FORM_STATE);

  const getEffectiveArea = useCallback(() => {
    if (selectedArea !== null) return selectedArea;
    if (availableAreas && availableAreas.length > 0) return availableAreas[0];
    return null;
  }, [selectedArea, availableAreas]);

  const handleInputChange = useCallback((field) => (e) => {
    setFormState((prev) => ({ ...prev, [field]: e.target.value }));
  }, []);

  const handleConfirm = useCallback(() => {
    const { targetPrice, targetJeonse } = formState;

    onConfirm({
      apt_no: aptNo,
      target_price: targetPrice !== '' ? Number(targetPrice) : null,
      target_jeonse: targetJeonse !== '' ? Number(targetJeonse) : null,
      area_size: getEffectiveArea(),
    });

    setFormState(INITIAL_FORM_STATE);
    setSelectedArea(null);
  }, [formState, aptNo, onConfirm, getEffectiveArea]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2">
      <div className="bg-white rounded-lg p-3 max-h-[90vh] overflow-auto w-[95%] sm:w-3/4 md:w-2/5">
        {/* Header */}
        <div className="flex justify-between items-center mb-3 sticky top-0 bg-white z-10 pb-2 border-b">
          <h2 className="text-lg sm:text-xl font-semibold">
            {apartmentName}
          </h2>
          <button
            onClick={onClose}
            aria-label="닫기"
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <MdOutlineCancel size={24} />
          </button>
        </div>

        {/* Area Selection */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            면적 선택
          </label>
          <div className="flex flex-wrap gap-2">
            {availableAreas.map((area) => {
              const isSelected = area === (selectedArea ?? availableAreas[0]);
              return (
                <button
                  key={area}
                  onClick={() => setSelectedArea(area)}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    isSelected
                      ? 'bg-blue-500 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {area}
                </button>
              );
            })}
          </div>
        </div>

        {/* Target Price */}
        <div className="mb-4">
          <label
            htmlFor="bookmark-target-price"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            매매 희망가 (만원)
          </label>
          <input
            id="bookmark-target-price"
            type="number"
            placeholder="예: 50000"
            value={formState.targetPrice}
            onChange={handleInputChange('targetPrice')}
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        {/* Target Jeonse */}
        <div className="mb-4">
          <label
            htmlFor="bookmark-target-jeonse"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            전세 희망가 (만원)
          </label>
          <input
            id="bookmark-target-jeonse"
            type="number"
            placeholder="예: 30000"
            value={formState.targetJeonse}
            onChange={handleInputChange('targetJeonse')}
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-2 pt-2 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
          >
            취소
          </button>
          <button
            onClick={handleConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 transition-colors"
          >
            저장
          </button>
        </div>
      </div>
    </div>
  );
}
